<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageTopButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageTopButtons"
          :key="index"
          v-bind="button"
          :disabled="button.enable"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="content">
      <ykc-detail-plus :labelWidth="120">
        <div slot="header" class="clearfix">
          <span class="title">广告</span>
        </div>
        <ykc-detail-item-plus label="广告名称">
          <span>{{ dealData(detail.name) }}</span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="广告位置">
          <span>{{ dealData(detail.launchTypeMean) }}</span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="广告状态">
          <span>
            {{ dealData(detail.statusMean) }}
          </span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="广告图片">
          <div class="block" @click="showPreView">
            <el-image
              style="width: 100px; height: 100px"
              :src="detail.image"
              :preview-src-list="[detail.image]"></el-image>
          </div>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="投放终端">
          {{ dealData(detail.launchTerminalTypeMean) }}
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="客户端跳转">
          <span>
            {{ dealData(detail.appSkipTypeMean) }}
          </span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="客户端跳转地址">
          <span>
            {{ dealData(detail.appSkipUrl) }}
          </span>
        </ykc-detail-item-plus>

        <ykc-detail-item-plus label="微信跳转">
          <span>
            {{ dealData(detail.wechatSkipTypeMean) }}
          </span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="微信小程序id">
          <span>
            {{ dealData(detail.wechatAppId) }}
          </span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="微信跳转路径">
          <span>
            {{ dealData(detail.wechatSkipUrl) }}
          </span>
        </ykc-detail-item-plus>

        <ykc-detail-item-plus label="投放时间">
          <span>
            {{ dealData(detail.launchBeginTime) + '到' + dealData(detail.launchEndTime) }}
          </span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="修改人">
          <span>{{ dealData(detail.modifiedName) }}</span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="修改时间">
          <span>{{ dealData(detail.modifiedTime) }}</span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="创建人">
          <span>{{ dealData(detail.createdName) }}</span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="创建时间">
          <span>{{ dealData(detail.createdTime) }}</span>
        </ykc-detail-item-plus>
        <ykc-detail-item-plus label="用户范围">
          <span>{{ dealData(detail.userScopeTypeMean) }}</span>
        </ykc-detail-item-plus>
        <!-- 地理位置维度 -->
        <ykc-detail-item-plus label="地理位置维度" v-if="showGeographyScope">
          <span v-if="detail.geographyType === 1">全国</span>
          <span v-else-if="detail.geographyType === 0">城市</span>
        </ykc-detail-item-plus>
        <!-- 投放电站字段 - 仅在特定广告位置下显示 -->
        <ykc-detail-item-plus label="投放电站" v-if="showStationTab || showStationTabWhenNoUser">
          <span>{{ dealData(detail.stationScopeTypeMean) }}</span>
        </ykc-detail-item-plus>
      </ykc-detail-plus>

      <!-- Tab切换 -->
      <ykc-detail :isHead="false" :tips="false" :className="'all'">
        <div
          slot="cvBody"
          v-if="showUserTab || showStationTabFrom || showStationTabWhenNoUser || showCityTab">
          <ykc-tabs
            headerButtonText="导出"
            :tabList="dynamicTabList"
            :active="activeTab"
            :rightHeaderNoMarginTop="true"
            :showHeaderButtons="showDownloadBtn"
            @btnClick="handleExportClick">
            <div slot="user" v-if="showUserTab">
              <ykc-table
                ref="YkcTable"
                v-show="detail.userScopeType !== '3'"
                :data="tableData"
                :columns="tableColumns"
                :title="tableTitle"
                operateFixedType="right">
                <ykc-pagination
                  slot="pagination"
                  ref="YkcPagination"
                  direct="flex-end"
                  :total="pageInfo.total"
                  :current-page.sync="pageInfo.current"
                  @current-change="handlePaginationCurrentChange"
                  :page-size.sync="pageInfo.size"
                  @size-change="handlePaginationSizeChange"></ykc-pagination>
              </ykc-table>
            </div>
            <div slot="station" v-if="showStationTabFrom || showStationTabWhenNoUser">
              <ykc-table
                ref="stationTable"
                :data="stationTableData"
                :columns="stationTableColumns"
                title="投放电站列表"
                operateFixedType="right">
                <ykc-pagination
                  slot="pagination"
                  ref="stationPagination"
                  direct="flex-end"
                  :total="stationPageInfo.total"
                  :current-page.sync="stationPageInfo.current"
                  @current-change="handleStationPaginationCurrentChange"
                  :page-size.sync="stationPageInfo.size"
                  @size-change="handleStationPaginationSizeChange"></ykc-pagination>
              </ykc-table>
            </div>
            <div slot="city" v-if="showCityTab">
              <ykc-table
                ref="cityTable"
                :data="cityTableData"
                :columns="cityTableColumns"
                title="投放城市列表"
                operateFixedType="right">
                <ykc-pagination
                  slot="pagination"
                  ref="cityPagination"
                  direct="flex-end"
                  :total="cityPageInfo.total"
                  :current-page.sync="cityPageInfo.current"
                  @current-change="handleCityPaginationCurrentChange"
                  :page-size.sync="cityPageInfo.size"
                  @size-change="handleCityPaginationSizeChange"></ykc-pagination>
              </ykc-table>
            </div>
          </ykc-tabs>
        </div>
      </ykc-detail>
    </div>
  </scroll-layout>
</template>

<script>
  import { adsApi } from '@/service/apis';
  import { offlineExport, dealData, code } from '@/utils';

  export default {
    name: 'platformCouponDetail',
    data() {
      return {
        id: '',
        visible: false,
        detail: {},
        userScopeType: '',
        activeTab: 'user', // 默认激活用户tab
        isEdit: false, // 添加这个属性

        pageTopButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
        pageButtons: [
          {
            id: '1',
            enabled: () => code('ads:downlist'),
            text: '导出',
            type: 'plain',
            handleClick: () => {
              this.doExportFile();
            },
          },
        ],
        // 电站相关的按钮和分页信息
        stationPageButtons: [
          {
            id: '1',
            enabled: () => code('ads:downlist'),
            text: '导出',
            type: 'plain',
            handleClick: () => {
              this.doStationExportFile();
            },
          },
        ],
        tableTitle: '',
        tableData: [],
        tableColumns: [],
        // 电站表格相关数据
        stationTableData: [],
        stationTableColumns: [
          { label: '电站编码', prop: 'dataId', minWidth: '120px' },
          { label: '电站名称', prop: 'dataName', minWidth: '150px' },
          { label: '电站类型', prop: 'stationTypeText', minWidth: '120px' },
          { label: '归属商户', prop: 'stationOperatorName', minWidth: '150px' },
        ],
        // 城市表格相关数据
        cityTableData: [],
        cityTableColumns: [
          { label: '省份', prop: 'provinceName', minWidth: '120px' },
          { label: '城市', prop: 'cityName', minWidth: '120px' },
        ],
        pageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
        // 电站分页信息
        stationPageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
        // 城市分页信息
        cityPageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
        searchParams: {
          id: this.id,
        },
        showDrawer: false,
        showDownloadBtn: false,
      };
    },
    computed: {
      // 是否显示电站tab，只有在特定广告位置下才显示
      showStationTab() {
        console.log('this.detail.launchType', this.detail.launchType);
        const stationRelatedTypes = ['5', '9', '6']; // 开始充电、开始充电-弹窗、实时订单
        return stationRelatedTypes.includes(this.detail.launchType);
      },
      // 是否显示电站tab，只有在特定广告位置下才显示
      showStationTabFrom() {
        console.log('this.detail.showStationTabFrom', this.detail.launchType);
        const stationRelatedTypes = ['5', '9', '6']; // 开始充电、开始充电-弹窗、实时订单
        return (
          stationRelatedTypes.includes(this.detail.launchType) &&
          this.detail.stationScopeType !== '4'
        );
      },
      // 当没有投放用户时也显示电站tab
      showStationTabWhenNoUser() {
        // 当用户范围为"全部"(id: '3')且是特定广告位置时显示电站tab
        return (
          this.detail.userScopeType === '3' && ['5', '9', '6'].includes(this.detail.launchType)
        );
      },
      showUserTab() {
        return this.detail.userScopeType !== '3';
      },
      showCityTab() {
        console.log('this.detail.geographyType', this.detail.geographyType);
        return this.detail.geographyType === 0 && this.showGeographyScope;
      },
      // 动态生成tab列表
      dynamicTabList() {
        const tabs = [];
        if (this.showUserTab) {
          tabs.push({
            label: '投放用户',
            name: 'user',
          });
        }
        // 仅在特定广告位置下添加投放电站tab
        if (this.showStationTabFrom || this.showStationTabWhenNoUser) {
          tabs.push({
            label: '投放电站',
            name: 'station',
          });
        }
        // 添加投放城市tab（仅在当地理位置维度为城市且在指定广告位置时显示）
        if (this.detail.geographyType === 0 && this.showGeographyScope) {
          tabs.push({
            label: '投放城市',
            name: 'city',
          });
        }

        return tabs;
      },
      showGeographyScope() {
        // 首页弹屏、电站列表、个人中心
        const geographyRelatedTypes = ['1', '4', '7'];
        return geographyRelatedTypes.includes(this.detail.launchType);
      },
    },
    created() {
      const { id, userScopeType, isEdit, stationScopeType } = this.$route.query;
      this.id = id || '';
      this.userScopeType = userScopeType || '';
      this.stationScopeType = stationScopeType || '';
      this.isEdit = isEdit === 'true'; // 将字符串转换为布尔值
      this.searchParams.id = id || '';
      this.showDownloadBtn = code('ads:downlist');
      this.getDetail();
      this.init();
    },
    methods: {
      dealData,
      // 格式化城市列表显示
      formatCityList(cityList) {
        if (!cityList || !Array.isArray(cityList) || cityList.length === 0) {
          return '未选择城市';
        }
        return cityList.map(item => `${item.provinceName}-${item.cityName}`).join(', ');
      },
      init() {
        // 根据用户范围和地理位置维度设置默认激活的tab
        debugger;
        if (this.userScopeType === '3') {
          if (this.stationScopeType !== '4') {
            // 当用户范围为"全部"时，默认激活电站tab
            this.activeTab = 'station';
          } else {
            // 如果地理位置维度为城市，则激活城市tab
            this.activeTab = 'city';
          }
        }

        if (this.userScopeType === '1') {
          this.searchTableList();
        }
        if (this.userScopeType === '2') {
          this.queryUserGroupForPage();
        }
        // 当没有投放用户或需要显示电站信息时查询电站列表
        if (this.detail.stationScopeType !== '4') {
          this.queryStationList();
        }
        this.queryCityInfoForPage();
      },
      // 导出按钮点击处理
      handleExportClick(value) {
        if (value === 'user') {
          this.doExportFile();
        } else if (value === 'station') {
          this.doStationExportFile();
        } else if (value === 'city') {
          this.doCityExportFile();
        }
      },
      /** 活动客户列表 */
      searchTableList() {
        const params = {
          ...this.searchParams,
          current: this.pageInfo.current,
          size: this.pageInfo.size,
        };
        adsApi.queryCustomerForPage(params).then(response => {
          this.tableData = response?.records || [];
          this.pageInfo.total = response?.total || 0;
        });
      },
      // 用户分组列表
      queryUserGroupForPage() {
        adsApi
          .queryUserGroupForPage({
            id: this.id,
            current: this.pageInfo.current,
            size: this.pageInfo.size,
          })
          .then(response => {
            this.tableData = response?.records || [];
            this.pageInfo.total = response?.total || 0;
          });
      },
      // 查询投放电站列表
      queryStationList() {
        adsApi
          .queryStationForPage({
            id: this.id,
            current: this.stationPageInfo.current,
            size: this.stationPageInfo.size,
          })
          .then(response => {
            this.stationTableData = response?.records || [];
            this.stationPageInfo.total = response?.total || 0;
          });
      },
      // 查询投放城市
      queryCityInfoForPage() {
        adsApi
          .queryCityInfoForPage({
            id: this.id,
            current: this.cityPageInfo.current,
            size: this.cityPageInfo.size,
          })
          .then(response => {
            this.cityTableData = response?.records || [];
            this.cityPageInfo.total = response?.total || 0;
          });
      },
      /** 导出文件 */
      doExportFile() {
        offlineExport(
          {
            downloadType: 'marketing_export',
            jsonNode: {
              downloadKey: 'customer_export',
              ...this.searchParams,
            },
          },
          this.pageInfo.total
        );
      },
      // 导出电站列表
      doStationExportFile() {
        offlineExport(
          {
            downloadType: 'marketing_export',
            jsonNode: {
              downloadKey: 'app_advertisement_station_export',
              ...this.searchParams,
            },
          },
          this.stationPageInfo.total
        );
      },
      // 导出城市列表
      doCityExportFile() {
        offlineExport(
          {
            downloadType: 'marketing_export',
            jsonNode: {
              downloadKey: 'city_export',
              ...this.searchParams,
            },
          },
          this.cityPageInfo.total
        );
      },
      /**
       * @desc 点击页面左上角按钮 callback
       * */
      handlePageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      // 电站页面按钮点击处理
      handleStationPageButtonClick(button, event) {
        if (typeof button.handleClick === 'function') {
          button.handleClick(button, event);
        }
      },
      /**
       * @desc 分页 change 事件监听器
       * */
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.init();
      },
      // 电站分页change事件
      handleStationPaginationCurrentChange(current) {
        this.stationPageInfo.current = current;
        this.queryStationList();
      },
      // 城市分页change事件
      handleCityPaginationCurrentChange(current) {
        this.cityPageInfo.current = current;
        this.queryCityInfoForPage();
      },
      showPreView() {
        this.visible = !this.visible;
      },
      /**
       * 分页 size  change  事件监听器
       * */
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.init();
      },
      // 电站分页size change事件
      handleStationPaginationSizeChange(size) {
        this.stationPageInfo.current = 1;
        this.stationPageInfo.size = size;
        this.queryStationList();
      },
      // 城市分页size change事件
      handleCityPaginationSizeChange(size) {
        this.cityPageInfo.current = 1;
        this.cityPageInfo.size = size;
        this.queryCityInfoForPage();
      },
      getDetail() {
        if (this.id) {
          adsApi
            .detail({ id: this.id })
            .then(res => {
              this.detail = res || {};
              this.$nextTick(() => {
                if (
                  this.detail.userScopeType === '3' &&
                  (this.detail.stationScopeType === null || this.detail.stationScopeType !== '4')
                ) {
                  this.activeTab = 'station';
                } else {
                  this.activeTab = 'city';
                }
                console.log(this.activeTab);
              });
              // 当用户范围为"全部"(id: '3')时，默认激活电站tab

              if (res.userScopeType === '1') {
                this.tableTitle = '活动客户列表';
                this.tableColumns = [
                  { label: '客户编码', prop: 'orgId', minWidth: '100px' },
                  { label: '客户名称', prop: 'orgName', minWidth: '100px' },
                  { label: '客户类型', prop: 'orgType', minWidth: '100px' },
                ];
              } else if (res.userScopeType === '2') {
                this.tableTitle = '活动分组列表';
                this.tableColumns = [
                  { label: '用户分组', prop: 'groupName', minWidth: '100px' },
                  { label: '用户数量', prop: 'userCount', minWidth: '100px' },
                ];
              }

              // 如果是编辑模式且地理位置维度为城市，则查询城市列表
              if (this.isEdit && res.geographyType === 0) {
                this.queryCityInfoForPage();
              }
            })
            .catch(() => {});
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .content {
    // display: flex;
    .clearfix {
      height: 19px;
      display: flex;
      align-items: center;
    }
    .box-card {
      margin: 0;
      &:first-child {
        margin-left: 0;
      }
      &:last-child {
        margin-right: 0;
      }
      .status {
        margin-left: 10px;
        color: #fff;
        height: 20px;
        border-radius: 10px;
        min-width: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 8px;
        line-height: 20px;
        &.stationStatus {
          &.status1000135 {
            background-color: #009f09;
          }
          &.status1000136 {
            background-color: #e81b1b;
          }
        }
        &.infoStatus {
          &.status1 {
            background-color: #009f09;
          }
          &.status2 {
            background-color: #ccc;
            color: #fff;
          }
          &.status0 {
            background-color: #e81b1b;
          }
        }
      }
      ::v-deep .el-form-item {
        display: flex;
        align-items: center;
      }
      table {
        width: calc(100% - 30px);
        border-left: 1px solid #ddd;
        border-top: 1px solid #ddd;
        margin-left: 30px;
        margin-top: 20px;
        th {
          background-color: #f6f7f8;
          font-weight: bold;
        }
        th,
        td {
          font-size: 12px;
          text-align: left;
          padding: 0 10px;
          line-height: 40px;
          height: 40px;
          border-right: 1px solid #ddd;
          border-bottom: 1px solid #ddd;
          ::v-deep .el-form-item {
            margin-bottom: 0;
            input {
              width: 100px;
            }
          }
        }
      }
      .title {
        position: relative;
        &-flag {
          margin-left: 8px;
          padding: 2px 18px;
          background: rgba(77, 140, 253, 0.1);
          border-radius: 2px;
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #4d8cfd;
          line-height: 17px;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }
    }
  }

  // Tab切换样式修改
  ::v-deep .ykc-tabs {
    // tab头部背景色
    .ykc-tabs__header {
      background-color: #f5f7fa;
      padding: 0 20px;
      margin-bottom: 20px;
    }

    // tab项样式
    .ykc-tabs__item {
      height: 40px;
      line-height: 40px;
      font-size: 14px;
    }

    // 选中tab的样式
    .ykc-tabs__item.is-active {
      color: #409eff !important;
      font-weight: 500;
    }

    // 选中tab的下划线颜色
    .ykc-tabs__active-bar {
      background-color: #409eff !important;
    }
  }
</style>
